import { useState } from 'react'
import { BsSuitHeart } from 'react-icons/bs'
import { BiCurrentLocation } from 'react-icons/bi'
import { GoHome } from 'react-icons/go'
import { HiOutlineUsers } from 'react-icons/hi'
import { MdSlowMotionVideo } from 'react-icons/md'

import Online from '../../components/online/Online'
import Home from '../pages/Home'
import Love from '../pages/Love'
import Friend from '../pages/Friend'
import Video from '../pages/Video'
import './content.css'

const Content = ({data}) => {

      const [toggle, setToggle] = useState(false)
      const [current, setCurrent] = useState('home')

      if(data.length === 0) return 
      
      const {infordata, galleries, banners, friends, videos, relation, social} = data.user 
      const id_xat = infordata.id_xat
      const TITLE = (banners.data ? "Welcome to my xatspace!" : banners[0].title)

      const default_data = {
            img: "https://i.postimg.cc/Rhfxcr48/banner.jpg",
            avatar: `https://api.dicebear.com/5.x/initials/svg?seed=${infordata.name}&font-size=26`,
            banner: "https://i.postimg.cc/08xg0Jgv/banner-bg.jpg"
      }

      const showMenu = () => {

            if(!toggle){
                  setToggle(true)
            }
            else{
                  setToggle(false)
            }
      }

      const setPage = (page) => {
            setCurrent(page)
      }

      return (
            <div className="content">
                  <div className="content_inner">
                        <div className="wrapper_banner__user">
                              <img src={galleries.data ? default_data.img : galleries[0].image} alt={galleries.data ? "Imagem Default" : galleries[0].description} />
                        </div>
                        <div className="container">
                              <div className="banner_content">
                                    <div className="banner_content__img">
                                          <img src={banners.data ? default_data.banner : banners[0].image} alt={banners.data ? "Banner Default" : banners[0].descrition} />
                                    </div>
                                    <div className="banner_content__desc">
                                          <Online id={id_xat} infor={infordata} avatar={default_data}/>
                                          <div className="banner_toggle">
                                                <button className="toggle_btn" onClick={() => showMenu()}>
                                                      <span className={toggle ? "toggle_btn_bar active" : "toggle_btn_bar"}></span>
                                                      <span className={toggle ? "toggle_btn_bar active" : "toggle_btn_bar"}></span>
                                                      <span className={toggle ? "toggle_btn_bar active" : "toggle_btn_bar"}></span>
                                                </button>
                                                <div className={toggle ? "toggle_menu active" : "toggle_menu"}>
                                                      <a href={infordata.homepage === '' ? "https://xat.com" : infordata.homepage} target="_blank" rel="noreferrer">Homepage</a>
                                                      <a href={infordata.xat_room === '' ? "https://xat.com" : infordata.xat_room} target="_blank" rel="noreferrer">Xat Room</a>
                                                      <a href={infordata.forum === '' ? "https://forum.xat.com" : infordata.forum} target="_blank" rel="noreferrer">Forum</a>
                                                </div>
                                          </div>
                                          <div className="banner_user">
                                                <div className="user_avatar_img">
                                                      <img src={infordata.avatar === '' ? default_data.avatar : infordata.avatar} alt={infordata.name} />
                                                </div>
                                                <div className="user_data">
                                                      <h1>{infordata.name}</h1>
                                                      <strong>{infordata.id_xat}</strong>
                                                      <p>{infordata.status}</p>
                                                      <div className="user_data_location">
                                                            <BiCurrentLocation />
                                                            <span>{infordata.location}</span>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div className="wrapper_pages">
                                    <div className="pages_group">
                                          <div className="pages_content">
                                                <Home isCurrent={current} data={infordata} title={TITLE} social={social} />
                                                <Love isCurrent={current} data={relation} />
                                                <Friend isCurrent={current} data={friends} />
                                                <Video isCurrent={current} data={videos} />
                                          </div>
                                    </div>
                                    <div className="pages_menu">
                                          <ul>
                                                <li className={current === 'home' ? "menu_item active" : "menu_item"} onClick={() => setPage('home')}>
                                                      <GoHome />
                                                      <span>Home</span>
                                                </li>
                                                <li className={current === 'love' ? "menu_item active" : "menu_item"} onClick={() => setPage('love')}>
                                                      <BsSuitHeart />
                                                      <span>Crush</span>
                                                </li>
                                                <li className={current === 'friend' ? "menu_item active" : "menu_item"} onClick={() => setPage('friend')}>
                                                      <HiOutlineUsers />
                                                      <span>Friends</span>
                                                </li>
                                                <li className={current === 'video' ? "menu_item active" : "menu_item"} onClick={() => setPage('video')}>
                                                      <MdSlowMotionVideo />
                                                      <span>Video</span>
                                                </li>
                                          </ul>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Content
